const TimeRange = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_WEEK: 'lastweek',
  LAST_YEAR: 'lastyear',
  YEAR: 'customYear',
  MONTH: 'customMonth',
  CUSTOM: 'customDate',
  ARCHIVE: 'archive',
};

export default TimeRange;
